import React from 'react';
import dayjs from 'dayjs';
import { useOrdersStatisticsQuery } from '@hooks/useOrdersQuery/useOrdersStatisticsQuery';
import { HomeAnalyticsView } from './HomeAnalyticsView';
const ninetyDaysAgo = dayjs().subtract(90, 'day').format('YYYY-MM-DDTHH:mm:ssZ');
const staleTime = 60_000; // 1 minute
export const HomeAnalyticsContainer = () => {
    const { getOrdersStatisticsQuery } = useOrdersStatisticsQuery([{ types: ['COMMON'], updatedAtIsAfter: ninetyDaysAgo }], {
        staleTime,
    });
    const hasOrderInLastNinetyDays = getOrdersStatisticsQuery.data && getOrdersStatisticsQuery.data.value > 0;
    if (!hasOrderInLastNinetyDays) {
        return null;
    }
    return React.createElement(HomeAnalyticsView, null);
};
